export default __webpack_public_path__ + "static/media/paper.bf428aef.png";